let Inline = Quill.import('blots/inline');
import Quill from 'quill';

export class FullWidthPlaceholderBlot extends Inline {
  static blotName = 'full-width-placeholder';
  static className = 'full-width-placeholder';
  static tagName = 'div';

  static create(value) {
    const node = super.create(value);

    node.setAttribute('contenteditable', false);
    return node;
  }

  static formats() {
    return true;
  }
}

Quill.register(FullWidthPlaceholderBlot);
